import React, {
  createRef,
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useFormikContext } from "formik";
import L from "leaflet"; // Import is necessary to function leaflet
import { EditControl } from "react-leaflet-draw";
import ReactDOM from "react-dom";
import { useMap } from "react-leaflet";

import { useCoursesContext } from "./CourseProvider";

import ENUMS from "../../../utils/ENUMS";
import MapBaseLayout from "../maps/MapBaseLayout";
import { Marker, Polyline, Tooltip } from "react-leaflet";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import { MAPS_CONFIG, TeePointMarker } from "../maps/utils";

import {
  Box,
  ButtonGroup,
  CssBaseline,
  Button,
  Tooltip as MaterialTooltip,
} from "@material-ui/core";
import {
  KeyboardArrowLeft,
  Edit,
  GolfCourse,
  SportsGolf,
  Delete,
  Undo,
} from "@material-ui/icons";
import Control from "react-leaflet-custom-control";
import { getAndRenderLines } from "./RenderLines";

const { MAPS } = ENUMS;

const CircleMarker = ({ geoJSON, msg }) => {
  const coord = [...geoJSON.geometry.coordinates];
  if (!coord.length) return "";

  return <TeePointMarker coords={coord.reverse()} msg={msg} />;
};
const CustomControl = ({ position = "topright", children }) => {
  const map = useMap();

  useEffect(() => {
    const controlDiv = L.DomUtil.create("div", "leaflet-custom-control");
    const control = L.control({ position });

    control.onAdd = () => {
      return controlDiv;
    };

    control.addTo(map);

    ReactDOM.render(children, controlDiv);

    return () => {
      ReactDOM.unmountComponentAtNode(controlDiv);
      control.remove();
    };
  }, [map, children, position]);

  return null;
};
const HoleShape = ({
  focusCoords,
  holesData,
  setFocusCoords,
  isActive,
  holeIndex,
  hole,
  course,
}) => {
  const { latitude, longitude, ...rest } = hole;

  const [holeCoords, setHoleCoords] = useState(hole.coordinate);
  const [featureGroupRef, setFeatureGroupRef] = useState(null);
  const [active, setActive] = useState("Hole");
  

  const _featureGroupRef = useRef();
  _featureGroupRef.current = featureGroupRef;

  const editRef = useRef();
  const [drawing, setDrawing] = useState(false);

  // Making the latest value accessible inside callbacks (reason : state would always show initial state)
  const holeCoordsRef = useRef();

  holeCoordsRef.current = holeCoords;

  const active_label = useRef();
  active_label.current = active;

  const { values, setFieldValue } = useFormikContext();

  const [centroid, setCentroid] = useState();

  const getMapsFormattedCoords = ({ lat, lng }) => [lat, lng];

  useEffect(() => {
    setCentroid(getMapsFormattedCoords(focusCoords));
  }, [focusCoords]);

  const _onEditControlReady = (drawControl) => {
    // store the edit ref for future access to content
    editRef.current = drawControl;
  };

  // Functionality for clearAll button in the Map Course
  const removeSelectedHoleLayers = (editRef) => {
    var layerContainer = editRef.current.options.edit.featureGroup;
    var layers = Object.values(layerContainer._layers).filter(
      ({ feature }) => feature.properties.holeIndex === hole.hole_index
    );

    var removable_layer_ids = Object.keys(layers);

    // console.log(removable_layer_ids, "layers remove");

    const deletableIds = Object.values(layers).map(
      ({ feature }) => feature.properties.id
    );

    let _holesCoords = { ...holeCoordsRef.current };

    removable_layer_ids.forEach((id) => {
      let layer = layers[id];
      layerContainer.removeLayer(layer);
    });

    _holesCoords["features"] = _holesCoords["features"].filter(
      (_hc) => !deletableIds.includes(_hc.properties.id)
    );
    setHoleCoords(_holesCoords);
    setActive(null);
  };

  // Functionality for Undo button in the Map Course
  const UndoLayer = (editRef) => {
    var layerContainer = editRef.current.options.edit.featureGroup;
    var layers = Object.values(layerContainer._layers).filter(
      ({ feature }) => feature.properties.holeIndex === hole.hole_index
    );

    var removable_layer_ids = Object.keys(layers).slice(-1);

    const deletableIds = Object.values(layers)
      .map(({ feature }) => feature.properties.id)
      .slice(-1);

    // console.log(deletableIds, "layers remove");

    let _holesCoords = { ...holeCoordsRef.current };

    removable_layer_ids.forEach((id) => {
      let layer = layers[id];
      layerContainer.removeLayer(layer);
    });

    _holesCoords["features"] = _holesCoords["features"].filter(
      (_hc) => !deletableIds.includes(_hc.properties.id)
    );
    setHoleCoords(_holesCoords);
    setActive(null);
  };

  //selecting button of map According to click

  const handleClick = (name) => {
    setActive(name);
    // if(name === "Hole" || name === "White Tee" || name === "Yellow Tee" || name === "Red Tee" ) {
    if (name === "Hole" || name === "White Tee") {
      const color = name.split(" ").at(0).toLowerCase();
      // console.log(editRef,"editRef")
      if (!drawing) {
        setTimeout(whiteTree, 50);

        function whiteTree() {
          editRef.current.options.draw.polygon.shapeOptions.color =
            name === "Hole" ? "#3388ff" : color;

          editRef.current._toolbars.draw._modes.polygon.handler.enable();
        }
      }
      // else {
      // editRef.current._toolbars.draw._modes.polygon.handler.completeShape()
      // editRef.current._toolbars.draw._modes.polygon.handler.disable()
      // }

      // setDrawing(!drawing)
    } else if (name === "Finish Point") {
      setTimeout(finish, 50);

      function finish() {
        editRef.current._toolbars.draw._modes.circle.handler.enable();
      }
    } else if (name === "Clear All") {
      removeSelectedHoleLayers(editRef);
      // editRef.current._toolbars.edit._modes.remove.handler.enable();
      // editRef.current._toolbars.edit._modes.remove.handler.removeAllLayers();
      // editRef.current._toolbars.edit._modes.remove.handler.save();
    } else if (name === "Undo") {
      UndoLayer(editRef);
    }
  };

  const saveHoleDetails = () => {
    const updatedCourses = [...values.data].map((_course) => {
      if (_course.course_name !== course.course_name) return _course;

      const updated_course = { ..._course };

      updated_course["hole_details"] = updated_course.hole_details.map(
        (_hole) => {
          if (_hole.hole_index !== hole.hole_index) return _hole;

          return {
            ..._hole,
            coordinate: holeCoordsRef.current,
          };
        }
      );

      return updated_course;
    });

    setFieldValue("data", updatedCourses);
  };

  useEffect(() => {
    saveHoleDetails();
  }, [holeCoords]);

  const _onCreate = useCallback(
    (e) => {
      const { layer } = e;
      if (!layer) return;

      const tempGeoJson = layer.toGeoJSON();

      const existingShapes = holeCoordsRef.current
        ? holeCoordsRef.current?.features?.map(({ geometry }) => geometry.type)
        : [];

      const PolygonCount = existingShapes.reduce(
        (a, c) => (c === "Polygon" ? a + 1 : a),
        0
      );

      const circleCount = existingShapes.reduce(
        (a, c) => (c === "Point" ? a + 1 : a),
        0
      );

      const lineCount = existingShapes.reduce(
        (a, c) => (c === "LineString" ? a + 1 : a),
        0
      );
      const shape = tempGeoJson.geometry.type;

      const removeCurrentLayer = () => {
        try {
          // removing the layer
          _featureGroupRef.current.removeLayer(layer);
        } catch (e) {}
      };

      // Adding unique identifier
      layer.feature = layer.feature || {
        properties: {
          id: Math.random(),
          createdAt: new Date().toISOString(),
          holeIndex: hole.hole_index,
        },
      };

      // Validating the current shape
      if (shape === "Polygon") {
        const firstPoint = layer.toGeoJSON().geometry.coordinates[0][0];
        setFocusCoords({ lat: firstPoint[0], lng: firstPoint[1] });

        // Set Label and Properties For Hole
        layer.feature.properties["toolTip"] = {
          permanent: active_label.current === "Hole" ? true : false,
          opacity: active_label.current === "Hole" ? 0.5 : 0,
          label: `${
            active_label.current === "Hole"
              ? `Hole ${hole.hole_index}`
              : active_label.current
          }`,
        };

        // Checking whether there is more than a polygon
        // if (PolygonCount > 0 && active_label.current==="Hole") {
        //     removeCurrentLayer()
        //     return toast.error('Only 1 Hole is allowed ')
        // }
        // else if (PolygonCount > 0 && active_label.current==="White Tee") {
        //     removeCurrentLayer()
        //     return toast.error('Only 1 Tee is allowed ')
        // }
        if (active_label.current === "Hole" && PolygonCount > 0) {
          removeCurrentLayer();
          // _featureGroupRef.current.removeLayer(layer)

          return toast.error("Hole is Already Drawn");
        }
        if (active_label.current === "White Tee" && PolygonCount > 1) {
          removeCurrentLayer();
          return toast.error("Tee is Already Drawn for this Hole");
        }

        const { label, ...rest } = layer.feature.properties["toolTip"];

        layer.bindTooltip(function (layer) {
          return label; //merely sets the tooltip text
        }, rest);
      } else if (shape === "Point") {
        // Checking whether there is more than two holes
        if (circleCount > 0) {
          removeCurrentLayer();
          return toast.error("Only 1 Finish Point is allowed on a hole");
        }

        if (circleCount === 0) {
          const firstPoint = layer.toGeoJSON().geometry.coordinates;
          setFocusCoords({ lat: firstPoint[0], lng: firstPoint[1] });
        }

        /* Lines not needed so this Functionality is not needed so commented out.
               Uncomment, if you want you use it again.

                // Checking if there is finish point so after that we can manually draw the lines
                if (circleCount === 1) {

                    // Method exported from RenderLines.js to programmatically draw thre lines
                    getAndRenderLines(holeCoordsRef, layer, _featureGroupRef, setHoleCoords);
            */

        layer.feature.properties["toolTip"] = {
          permanent: false,
          opacity: 1,
          offset: [15, -40],
          label: "Finish Point",
          radius: layer.options.radius,
        };

        const { label, ...rest } = layer.feature.properties["toolTip"];

        layer.bindTooltip(function (layer) {
          return label; //merely sets the tooltip text
        }, rest);
      }
     

      const geoJSON = layer.toGeoJSON();
      geoJSON["type"] = "Feature";

      // debugger

      setHoleCoords(({ features, ...rest }) => {
        return {
          ...rest,
          features: [...features, geoJSON],
        };
      });
    },
    [featureGroupRef, hole.hole_index]
  );

  const _onEdited = useCallback((e) => {
    const { layers } = e;
    if (!layers) return;

    const editedFeatures = layers.toGeoJSON().features;

    // Set Holes Coordinates
    let _holesCoords = { ...holeCoordsRef.current };

    console.log(_holesCoords, "holeCoords");

    // Functionality for editing the polygon part
    _holesCoords["features"] = _holesCoords["features"].map((_hc) => {
      console.log(editedFeatures, "edited Features");
      console.log(_hc, "hc");
      const id = _hc.properties.id;

      const editedFeature = editedFeatures.filter((ef) => {
        const { geometry, properties } = ef;
        return ef.properties.id === id;
      });

      if (editedFeature.length > 0) {
        console.log(editedFeature[0].geometry, "edited Feature");
        console.log(_hc, "hc");
        return {
          ..._hc,
          geometry: editedFeature[0].geometry,
        };
      }

      console.log(_hc, "hc");

      return _hc;
    });
    setHoleCoords(_holesCoords);
    setActive(null);
  }, []);

  const _onDeleted = useCallback((e) => {
    const { layers } = e;
    if (!layers) return;

    let _holesCoords = { ...holeCoordsRef.current };

    const deletableIds = Object.values(layers._layers).map(
      ({ feature }) => feature.properties.id
    );

    _holesCoords["features"] = _holesCoords["features"].filter(
      (_hc) => !deletableIds.includes(_hc.properties.id)
    );
    setHoleCoords(_holesCoords);
    // window.location.reload();
  }, []);

  if (!isActive) {
    return "";
  }

  return (
    <MapBaseLayout
      center={centroid}
      zoom={focusCoords.zoom}
      style={{ height: "50vh", width: "100%", minHeight: "50rem" }}
      geoJsonData={holeCoords}
      holesData={holesData}
      holeIndex={holeIndex}
      onFeatureGroupCreate={setFeatureGroupRef}
      featureGroupChildren={
        <Fragment>
          <CustomControl position="topright">
            <CssBaseline /> 
             <ButtonGroup
              orientation="horizontal"
              variant="text"
              sx={{ gridGap: "2rem" }}
            >
              <Button
                style={{
                  textTransform: "none",
                  fontSize: "1.5rem",
                  backgroundColor: "#3d6321",
                  color: "white",
                  marginLeft: "2rem",
                  borderRadius: "1rem",
                }}
                startIcon={<GolfCourse />}
                color={"error"}
                onClick={() => handleClick("Hole")}
                variant="contained"
              >
                Map Hole
              </Button>
              <Button
                style={{
                  textTransform: "none",
                  fontSize: "1.5rem",
                  marginLeft: "2rem",
                  borderRadius: "1rem",
                }}
                startIcon={<Edit />}
                color={"inherit"}
                onClick={() => handleClick("White Tee")}
                variant="contained"
              >
                {/*White Tee*/}
                Draw a Tee
              </Button>
              {/*<Button*/}
              {/*style={{textTransform: "none", fontSize: "1.5rem", color: "white", backgroundColor: "#F6BE00", marginLeft: "2rem", borderRadius: "1rem"}}*/}
              {/*startIcon={<Edit />}*/}
              {/*color={"primary"}*/}
              {/*onClick={() => handleClick("Yellow Tee")}*/}
              {/*variant="contained"*/}
              {/*>*/}
              {/*Yellow Tee*/}
              {/*</Button>*/}
              {/*<Button*/}
              {/*style={{textTransform: "none", fontSize: "1.5rem", marginLeft: "2rem", borderRadius: "1rem"}}*/}
              {/*startIcon={<Edit />}*/}
              {/*color={"secondary"}*/}
              {/*onClick={() => handleClick("Red Tee")}*/}
              {/*variant="contained"*/}
              {/*>*/}
              {/*Red Tee*/}
              {/*</Button>*/}
              <Button
                style={{
                  textTransform: "none",
                  fontSize: "1.5rem",
                  marginLeft: "2rem",
                  borderRadius: "1rem",
                }}
                color={"inherit"}
                startIcon={<SportsGolf />}
                onClick={() => handleClick("Finish Point")}
                variant="contained"
              >
                Finish Point
              </Button>
              <Button
                style={{
                  textTransform: "none",
                  fontSize: "1.5rem",
                  color: "white",
                  backgroundColor: "grey",
                  marginLeft: "2rem",
                  borderRadius: "1rem",
                }}
                color={"primary"}
                startIcon={<Undo />}
                onClick={() => handleClick("Undo")}
                variant="contained"
              >
                Undo
              </Button>
              <Button
                style={{
                  textTransform: "none",
                  fontSize: "1.5rem",
                  color: "white",
                  backgroundColor: "grey",
                  marginLeft: "2rem",
                  borderRadius: "1rem",
                }}
                color={"primary"}
                startIcon={<Delete />}
                onClick={() => handleClick("Clear All")}
                variant="contained"
              >
                Clear All
              </Button>
            </ButtonGroup>
          </CustomControl>
          <EditControl
            onMounted={_onEditControlReady}
            position="bottomright"
            onCreated={_onCreate}
            onEdited={_onEdited}
            draw={{
              polygon: {
                shapeOptions: { opacity: 1 },
              },
              rectangle: false,
              polyline: false,
              circle: {
                shapeOptions: { color: "red", opacity: 1 },
              },
              circlemarker: false,
              marker: { icon: MAPS_CONFIG.FinishPointIcon },
            }}
            edit={{
              // featureGroup: editableLayers, //REQUIRED!!
              edit: true,
            }}
          />
        </Fragment>
      }
    >
      {/* <Marker position={focusCoords} /> */}
    </MapBaseLayout>
  );
};

const CourseCard = ({ isActive, mapRef, ...rest }) => {
  const formik = useFormikContext();
  const { onSubmit } = useCoursesContext();
  const {
    hole_details: holesList,
    course_name,
    latitude,
    longitude,
    club_postcode,
  } = rest.course;

  const [activeHoleIndex, setActiveHoleIndex] = useState(
    holesList.length ? 1 : null
  );

  const [coords, setCoords] = useState({
    lat: latitude || MAPS.DEFAULT_LAT,
    lng: longitude || MAPS.DEFAULT_LNG,
    zoom: MAPS.ZOOM_LEVEL,
  });

  const [finalCoords, setFinalCoords] = useState(coords);
  const [zipCode, setZipCode] = useState(club_postcode);

  const handleZipCode = async () => {
    if (zipCode.length < 6 || zipCode.length > 8) {
      toast.error("Invalid Zip code ");
    } else {
      try {
        const res = await axios.get(
          `https://nominatim.openstreetmap.org/search.php?q=${zipCode}&polygon_geojson=1&format=jsonv2`
        );
        const result = [
          Number(res.data[0].lat).toFixed(6),
          Number(res.data[0].lon).toFixed(6),
        ];
        setFinalCoords({
          ...coords,
          lat: Number(result[0]),
          lng: Number(result[1]),
        });
      } catch (err) {
        console.log(err, "err");
      }
    }
  };

  useEffect(() => {
    try {
      if (isActive && holesList.length) {
        const holeData = holesList[activeHoleIndex - 1];
        const prevHoleData = holesList[activeHoleIndex - 2];

        const point = holeData.coordinate.features.find(
          (f) => f.geometry.type === "Point"
        );
        const prevPoint = prevHoleData
          ? prevHoleData.coordinate.features.find(
              (f) => f.geometry.type === "Point"
            )
          : null;
        if (point) {
          const [lng, lat] = point.geometry.coordinates;
          // TODO Focus on Center
          setFinalCoords({
            // lat:51.96319,
            // lng:-0.263916,
            lat,
            lng,
            zoom: 33,
          });
        } else if (prevPoint) {
          const [lng, lat] = prevPoint.geometry.coordinates;
          // TODO Focus on Center
          setFinalCoords({
            lat,
            lng,
            zoom: MAPS.ZOOM_LEVEL,
          });
        } else if (club_postcode.length > 5) {
          console.log(zipCode);
          handleZipCode();
        }
      }
    } catch (e) {
      console.log(e);
    }

    // return () => {
    //     isActive = false;
    // }
  }, [activeHoleIndex, isActive]);
  const changeBtnHandle = (data) => {
    setActiveHoleIndex(data);
    onSubmit(formik, true);
    // handleRunData()
  };

  if (!isActive) return "";

  return (
    <Fragment>
      <h2 className="c-mapping__box-txt text-jost-sb-24">
        Course mapping for {course_name}
      </h2>

      <p className="c-mapping__box-para text-ops-rg-16">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean porta,
        felis vitae accumsan semper, urna velit consequat nibh.
      </p>

      <div className="c-mapping__box__link">
        <div className="c-mapping__box__link-left">
          <input
            type="text"
            name="lat"
            placeholder="PostCode"
            className="form__input-md"
            onChange={(e) => setZipCode(e.target.value)}
            defaultValue={zipCode}
          />

          <button
            type="button"
            className="res-btn-primary"
            onClick={handleZipCode}
          >
            continue
          </button>
        </div>

        <button
          ref={mapRef}
          className="res-btn-gray c-mapping__box__link-right"
        >
          Need some help? Watch this
          <img
            src={require("../../../assets/images/btn/Play_Button.svg").default}
            alt="video player"
          />
        </button>
      </div>

      {holesList.map((_hole, index) => (
        <HoleShape
          {...rest}
          key={index.toString()}
          focusCoords={finalCoords}
          setFocusCoords={setFinalCoords}
          hole={_hole}
          holeIndex={index}
          holesData={holesList}
          isActive={_hole.hole_index === activeHoleIndex}
        />
      ))}

      <div className="c-mapping__box__btn">
        {holesList.map((hole, index) => (
          <button
            key={index.toString()}
            className={`hole_btn ${
              activeHoleIndex === hole.hole_index ? "active" : ""
            }`}
            onClick={() => changeBtnHandle(hole.hole_index)}
            // onClick={() => setActiveHoleIndex(hole.hole_index)}
          >
            HOLE {hole.hole_index}
          </button>
        ))}
      </div>
    </Fragment>
  );
};

const CourseMapsDetails = () => {
  const formik = useFormikContext();
  const { data, activeCourseIndex, clicking } = formik.values;
  const mapRef = useRef();

  const executeScroll = () =>
    mapRef.current.scrollIntoView({ behavior: "smooth" });

  const { onSubmit } = useCoursesContext();

  useEffect(() => {
    if (data.length) {
      executeScroll();
    }
  }, [activeCourseIndex, clicking]);

  const handleCourseDetails = () => {
    onSubmit(formik);
  };

  if (activeCourseIndex === null || !data.length) return "";

  return (
    <div className="c-mapping__box">
      <ToastContainer />

      {data.map((course, i) => (
        <CourseCard
          key={i.toString()}
          course={course}
          isActive={activeCourseIndex === i}
          mapRef={mapRef}
        />
      ))}

      <button
        type="submit"
        className="res-btn-primary c-mapping__box-next"
        onClick={handleCourseDetails}
      >
        Save Course
      </button>
    </div>
  );
};

export default CourseMapsDetails;
